export const SCOPE_INIT = "scope/init";
export const SCOPE_GET_GRAPHCLIENT = "scope/get/graphClient";
export const SCOPE_INIT_GRAPHCLIENT = "scope/init/graphClient";
